/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_User_Saved_SuccessInputs */



/**
* | output |
* | --- |
* | "User record saved successfully" |
*
* @param {Team_Manager_User_Saved_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_user_saved_success = /** @type {((inputs?: Team_Manager_User_Saved_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_User_Saved_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement de l’utilisateur réussi")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerdatensatz erfolgreich gespeichert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Record utente salvato correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запись пользователя успешно сохранена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El registro de usuario se guardó correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用户记录已成功保存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーレコードが正常に保存されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता का रिकॉर्ड सफलतापूर्वक सहेज लिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Registro do usuário salvo com sucesso")
	return /** @type {LocalizedString} */ ("User record saved successfully")
});